import React, { createContext, useMemo, PropsWithChildren } from "react";
import type { TicketMasterApolloClientProps } from "../../TicketMasterApolloClient/TicketMasterApolloClient";
import type { EndpointConfig } from "../../Ticketing/TicketingAPI";

export type { EndpointConfig };

export interface AutomationSystemsContextType {
  editTicketingSystemAllowed: boolean;
  apolloClient?: TicketMasterApolloClientProps["apolloClient"];
  endpointConfig?: EndpointConfig;
}

export const AutomationSystemsContext = createContext<
  AutomationSystemsContextType | {}
>({});

export interface AutomationSystemsProviderProps
  extends PropsWithChildren,
    AutomationSystemsContextType {}

const AutomationSystemsProvider: React.FC<AutomationSystemsProviderProps> = ({
  children,
  editTicketingSystemAllowed,
  apolloClient,
  endpointConfig,
}) => {
  const value = useMemo(
    () => ({
      editTicketingSystemAllowed,
      apolloClient,
      endpointConfig,
    }),
    [editTicketingSystemAllowed, apolloClient, endpointConfig]
  );

  return (
    <AutomationSystemsContext.Provider value={value}>
      {children}
    </AutomationSystemsContext.Provider>
  );
};

export default AutomationSystemsProvider;
